module.exports = __webpack_public_path__ + "img/node-js.a1231528.svg";